import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input } from 'reactstrap';

interface DependentType {
  id: number;
  nome: string;
  apelido: string;
  idade: string;
  relacao_responsavel: string;
  contato_emergencia: string;
  contato_emergencia_opcional: string;
  possui_deficiencia_invisivel: boolean;
  tipo_dependente: string;
  especie: string;
  veterinario: string;
  veterinario_contato: string;
  condicoes_medicas: string[];
  alergias: string[];
  medicacoes: string[];
  tipo_deficiencia: string[];
  equipamentos_assistencia: string[];
  user: {
    name: string;
    email: string;
    cpf: string;
    phone: string;
  };
}

interface PropsEvent {
  isOpen: boolean;
  handleIsOpen: () => void;
  company: DependentType;
}

export function ModalEditDependent({
  isOpen,
  handleIsOpen,
  company,
}: PropsEvent): React.JSX.Element {
  function close(): void {
    handleIsOpen();
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const formatArray = (arr: string[]) => (arr?.length ? arr.join(', ') : 'Nenhum');

  return (
    <Modal isOpen={isOpen} toggle={close} size={'lg'}>
      <ModalHeader toggle={close}>Detalhes do Dependente</ModalHeader>
      <ModalBody>
        <Form>
          {/* Identificação */}
          <h6 className="mb-3">Identificação</h6>
          <div className="row">
            <div className="col-md-6">
              <FormGroup>
                <Label>Nome</Label>
                <Input value={company.nome} disabled />
              </FormGroup>
            </div>
            <div className="col-md-3">
              <FormGroup>
                <Label>Apelido</Label>
                <Input value={company.apelido} disabled />
              </FormGroup>
            </div>
            <div className="col-md-3">
              <FormGroup>
                <Label>Idade</Label>
                <Input value={company.idade} disabled />
              </FormGroup>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <FormGroup>
                <Label>Tipo de Dependente</Label>
                <Input value={company.tipo_dependente} disabled />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>Espécie</Label>
                <Input value={company.especie} disabled />
              </FormGroup>
            </div>
          </div>

          {/* Contato */}
          <h6 className="mt-4 mb-3">Contato</h6>
          <div className="row">
            <div className="col-md-6">
              <FormGroup>
                <Label>Relação com o Responsável</Label>
                <Input value={company.relacao_responsavel} disabled />
              </FormGroup>
            </div>
            <div className="col-md-3">
              <FormGroup>
                <Label>Contato de Emergência</Label>
                <Input value={company.contato_emergencia} disabled />
              </FormGroup>
            </div>
            <div className="col-md-3">
              <FormGroup>
                <Label>Contato de Emergência</Label>
                <Input value={company.contato_emergencia_opcional} disabled />
              </FormGroup>
            </div>
          </div>

          {/* Saúde */}
          <h6 className="mt-4 mb-3">Informações de Saúde</h6>
          <div className="row">
            <div className="col-md-4">
              <FormGroup>
                <Label>Deficiência Invisível</Label>
                <Input value={company.possui_deficiencia_invisivel ? 'Sim' : 'Não'} disabled />
              </FormGroup>
            </div>
            <div className="col-md-8">
              <FormGroup>
                <Label>Tipo de Deficiência</Label>
                <Input value={formatArray(company.tipo_deficiencia)} disabled />
              </FormGroup>
            </div>
          </div>

          <FormGroup>
            <Label>Condições Médicas</Label>
            <Input value={formatArray(company.condicoes_medicas)} disabled />
          </FormGroup>

          <FormGroup>
            <Label>Alergias</Label>
            <Input value={formatArray(company.alergias)} disabled />
          </FormGroup>

          <FormGroup>
            <Label>Medicações</Label>
            <Input value={formatArray(company.medicacoes)} disabled />
          </FormGroup>

          <FormGroup>
            <Label>Equipamentos de Assistência</Label>
            <Input value={formatArray(company.equipamentos_assistencia)} disabled />
          </FormGroup>

          {/* Veterinário */}
          <h6 className="mt-4 mb-3">Veterinário</h6>
          <div className="row">
            <div className="col-md-6">
              <FormGroup>
                <Label>Nome do Veterinário</Label>
                <Input value={company.veterinario} disabled />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>Contato</Label>
                <Input value={company.veterinario_contato} disabled />
              </FormGroup>
            </div>
          </div>

          {/* Responsável */}
          <hr />
          <h6 className="mt-4 mb-3">Responsável</h6>
          <div className="row">
            <div className="col-md-6">
              <FormGroup>
                <Label>Nome</Label>
                <Input value={company.user.name} disabled />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>Email</Label>
                <Input value={company.user.email} disabled />
              </FormGroup>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <FormGroup>
                <Label>CPF</Label>
                <Input value={company.user.cpf} disabled />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>Telefone</Label>
                <Input value={company.user.phone} disabled />
              </FormGroup>
            </div>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
}
